import React, { useEffect, useContext, useState } from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import { BlogContext } from '../../context/BlogContext';
import { Link, useNavigate } from 'react-router-dom';
import PostCard from '../Layout/PostCard';
import '../../style/Blog.css';

const UserProfile = () => {
  const { user, userLoaded } = useContext(AuthContext);
  const { getMyBlogs } = useContext(BlogContext);
  const [myBlogs, setMyBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (userLoaded && !user) {
      navigate('/login');
    }
  }, [userLoaded, user, navigate]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogs = await getMyBlogs();
        setMyBlogs(blogs);
      } catch (err) {
        // console.error('Error fetching blogs:', err);
        setError('Failed to load your posts. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      fetchBlogs();
    }
  }, [user, getMyBlogs]);

  if (!userLoaded || loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="dark" />
      </div>
    );
  }

  if (!user) {
    return (
      <Container className="text-center mt-5">
        <Alert variant="warning">You must be logged in to view your profile.</Alert>
        <Link to="/login" className="retro-button mt-3">Login</Link>
      </Container>
    );
  }

  const filteredBlogs = [...myBlogs]
    .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
    .filter(blog =>
      blog.title?.toLowerCase().includes(searchTerm.toLowerCase())
    );

  return (
    <Container className="mt-5 mb-4">
      {/* Profile Header */}
      <div className="retro-window mb-5">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h1 className="text-center fw-bold mb-2">{user.username}</h1>
        <p className="text-center fs-5 fst-italic mb-4">Email: {user.email || 'N/A'}</p>
      </div>

      {/* Posts Header and Search */}
      <div className="retro-window mb-5">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h1 className="text-center mb-4">My Posts</h1>
        <div className="mb-3 text-center">
          <input
            type="text"
            className="form-control w-75 mx-auto"
            placeholder="Search by title..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="text-center mb-4">
          <Alert variant="danger">{error}</Alert>
        </div>
      )}

      {/* Posts Grid */}
      <Row className="justify-content-center g-4">
        {filteredBlogs.length === 0 ? (
          <Col xs={12} className="text-center">
            <p>No posts yet.</p>
          </Col>
        ) : (
          filteredBlogs.map(blog => (
            <Col key={blog._id} xs={12} md={6} lg={4}>
              <PostCard post={blog} />
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
};

export default UserProfile;
